import { useEffect, useRef, useState } from 'react';

const FLOOR_TMS_URL = 'https://4s-dev.com/maps/tiles/{z}/{x}/{y}.png';

export const useMapOverlays = (map: google.maps.Map | null, isLoaded: boolean) => {
  const [floorOn, setFloorOn] = useState(false);

  const mapRef = useRef<google.maps.Map | null>(null);
  const floorOverlayRef = useRef<google.maps.ImageMapType | null>(null);

  // map ref 동기화
  useEffect(() => {
    mapRef.current = map;
  }, [map]);

  // 오버레이 레이어 관리
  useEffect(() => {
    if (!isLoaded || !mapRef.current) return;

    if (floorOn) {
      attachFloorOverlay();
    } else {
      detachFloorOverlay();
    }
  }, [floorOn, isLoaded]);

  const attachFloorOverlay = () => {
    const m = mapRef.current;
    if (!m || floorOverlayRef.current) return;

    const floorLayer = new google.maps.ImageMapType({
      name: 'FloorPlan',
      tileSize: new google.maps.Size(256, 256),
      minZoom: 16,
      maxZoom: 22,
      getTileUrl: (coord, zoom) => {
        const tmsY = (1 << zoom) - coord.y - 1;
        return FLOOR_TMS_URL.replace('{z}', String(zoom))
          .replace('{x}', String(coord.x))
          .replace('{y}', String(tmsY));
      }
    });

    m.overlayMapTypes.push(floorLayer);
    floorOverlayRef.current = floorLayer;
  };

  const detachFloorOverlay = () => {
    const m = mapRef.current;
    const overlay = floorOverlayRef.current;
    if (!m || !overlay) return;

    const overlays = m.overlayMapTypes;
    for (let i = overlays.getLength() - 1; i >= 0; i--) {
      if (overlays.getAt(i) === overlay) {
        overlays.removeAt(i);
        break;
      }
    }
    floorOverlayRef.current = null;
  };

  return { floorOn, setFloorOn, mapRef };
};
